<template>
  <div
    v-if="hint"
    class="RMPE-MessageHint"
  >
    <div
      class="help"
      v-html="hint"
    />
  </div>
</template>

<script>
export default {
  props: {
    hint: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
<style scoped lang="scss">
.RMPE-MessageHint {}
</style>
